export default __webpack_public_path__ + "static/media/envmap.ba47e033.jpg";